module.exports = __webpack_public_path__ + "yaaro_phone.60f577fbac.webp";